import { createSlice } from '@reduxjs/toolkit'

// Obtener preferencia guardada o del sistema
const getInitialMode = () => {
  const savedMode = localStorage.getItem('themeMode')
  if (savedMode) {
    return savedMode
  }
  // Detectar preferencia del sistema
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark'
  }
  return 'light'
}

const initialState = {
  mode: getInitialMode(), // 'light' o 'dark'
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light'
      localStorage.setItem('themeMode', state.mode)
    },
    setThemeMode: (state, action) => {
      state.mode = action.payload
      localStorage.setItem('themeMode', state.mode)
    },
  },
})

export const { toggleTheme, setThemeMode } = themeSlice.actions
export default themeSlice.reducer
